export const BOOKING_URL = "https://usddacademy.as.me/";

export const SITE = {
  name: "USDD Academy",
  tagline: "Upside Down Dance Academy",
  logo: "https://customer-assets.emergentagent.com/job_17a0c012-4115-4925-8e00-832711951fe2/artifacts/oj16ngj3_USDD%20Academy%20logo%20.png",
  kidsLogo: "https://customer-assets.emergentagent.com/job_17a0c012-4115-4925-8e00-832711951fe2/artifacts/a0am21tx_USDD_kids_logo.png",
  kidsShow: "https://customer-assets.emergentagent.com/job_17a0c012-4115-4925-8e00-832711951fe2/artifacts/95vzbs7f_USDD%20Kids%20show.png",
  battle: "https://customer-assets.emergentagent.com/job_17a0c012-4115-4925-8e00-832711951fe2/artifacts/68qy7ifh__DAP1437_1080px.jpg",
  hero: "https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?auto=format&fit=crop&w=1920&q=80",
  classImg1: "https://images.pexels.com/photos/13993467/pexels-photo-13993467.jpeg?auto=compress&cs=tinysrgb&w=1200",
  classImg2: "https://images.unsplash.com/photo-1604954055722-7f80571fbfc3?auto=format&fit=crop&w=1200&q=80",
  classImg3: "https://images.unsplash.com/photo-1535525153412-5a42439a210d?auto=format&fit=crop&w=1200&q=80",
  classImg4: "https://images.unsplash.com/photo-1547153760-18fc86324498?auto=format&fit=crop&w=1200&q=80",
  classImg5: "https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=1200&q=80",
  classImg6: "https://images.unsplash.com/photo-1524594152303-9fd13543fe6e?auto=format&fit=crop&w=1200&q=80",
  classImg7: "https://images.unsplash.com/photo-1519682337058-a94d519337bc?auto=format&fit=crop&w=1200&q=80",
  socialImg1: "https://images.unsplash.com/photo-1545128485-c400e7702796?auto=format&fit=crop&w=1200&q=80",
  socialImg2: "https://images.unsplash.com/photo-1504609813442-a8924e83f76e?auto=format&fit=crop&w=1200&q=80",
  socialImg3: "https://images.pexels.com/photos/2034851/pexels-photo-2034851.jpeg?auto=compress&cs=tinysrgb&w=1200",
  pathwayBg: "https://images.unsplash.com/photo-1621976360623-004223992275?auto=format&fit=crop&w=1600&q=80",
  contact: {
    email: "info@usddnetworks.co.uk",
    phone: "07513 192613",
    locations: ["London", "Medway", "Chatham", "Elephant & Castle", "Kent"],
  },
  socials: {
    instagram_main: { handle: "@usddacademy", url: "https://instagram.com/usddacademy" },
    instagram_kids: { handle: "@usddkids", url: "https://instagram.com/usddkids" },
    instagram_media: { handle: "@usddnetworks", url: "https://instagram.com/usddnetworks" },
    youtube: { handle: "USDD Networks", url: "https://youtube.com/@usddnetworks" },
    tiktok_networks: { handle: "@usddnetworks", url: "https://tiktok.com/@usddnetworks" },
    tiktok_kids: { handle: "@usddkids1", url: "https://tiktok.com/@usddkids1" },
  },
};
